import type { FitPointMeta, Preferences, Preferred } from "../api/types";

const ROOM_CHOICES: [Preferred, string][] = [
  ["snug", "Snug"],
  ["favorite", "Like my favorite"],
  ["roomy", "Roomy"],
];
const LENGTH_CHOICES: [Preferred, string][] = [
  ["snug", "Shorter"],
  ["favorite", "Like my favorite"],
  ["roomy", "Longer"],
];

/** The chips for "you like it…": room for most fit points, Shorter / Longer for a length. */
export const prefChoices = (fp: Pick<FitPointMeta, "length">) => (fp.length ? LENGTH_CHOICES : ROOM_CHOICES);
export const ALTER_CHOICES: [keyof Preferences["alter"], string][] = [
  ["hem", "Would hem"],
  ["take_in", "Would take in"],
  ["never", "Never alter"],
];

/** Toggle an alteration chip. "Never alter" excludes the other two. */
export function toggleAlter(a: Preferences["alter"], k: keyof Preferences["alter"]): Preferences["alter"] {
  const on = !a[k];
  if (k === "never") return on ? { hem: false, take_in: false, never: true } : { ...a, never: false };
  return { ...a, [k]: on, never: on ? false : a.never };
}

/** Replace the general (cut_group null) preference for each picked fit point; keep everything else. */
export function mergePrefItems(items: Preferences["items"], picked: Record<string, Preferred>): Preferences["items"] {
  const out = items.filter((it) => it.cut_group !== null || !(it.fit_point in picked));
  Object.entries(picked).forEach(([fit_point, preferred]) => out.push({ fit_point, cut_group: null, preferred }));
  return out;
}
